import { Controller } from "@hotwired/stimulus"

// The "Dnes" queue's keyboard: j / k move the selection, x marks the
// selected row done, s snoozes it a day, Enter opens its company. Keys
// typed into a field, or with a modifier, are left alone. After an action
// the page comes back at the next row (the form sends its id as `next`,
// the server answers with it as the anchor).
export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.onKey = this.key.bind(this)
    this.onSubmit = this.remember.bind(this)
    document.addEventListener("keydown", this.onKey)
    this.element.addEventListener("submit", this.onSubmit)
    const anchored = window.location.hash && this.itemTargets.find((item) => `#${item.id}` === window.location.hash)
    this.select(anchored ? this.itemTargets.indexOf(anchored) : 0, false)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
    this.element.removeEventListener("submit", this.onSubmit)
  }

  key(event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return
    if (event.target.closest("input, textarea, select, [contenteditable]")) return

    switch (event.key) {
      case "j": this.select(this.index + 1); break
      case "k": this.select(this.index - 1); break
      case "x": this.press("x"); break
      case "s": this.press("s"); break
      case "Enter": this.open(); break
      default: return
    }
    event.preventDefault()
  }

  select(index, focus = true) {
    if (this.itemTargets.length === 0) return
    this.index = Math.max(0, Math.min(index, this.itemTargets.length - 1))
    this.itemTargets.forEach((item, i) => item.toggleAttribute("data-selected", i === this.index))
    const item = this.itemTargets[this.index]
    if (focus) {
      item.focus({ preventScroll: true })
      item.scrollIntoView({ block: "nearest" })
    }
  }

  get current() { return this.itemTargets[this.index] }

  press(shortcut) {
    const button = this.current?.querySelector(`[data-today-shortcut="${shortcut}"]`)
    if (button) button.click()
  }

  open() {
    const url = this.current?.dataset.url
    if (!url) return
    if (window.Turbo) window.Turbo.visit(url)
    else window.location.assign(url)
  }

  remember(event) {
    const row = event.target.closest("[data-today-target='item']")
    if (!row) return
    const rows = this.itemTargets
    const next = rows[rows.indexOf(row) + 1] || rows[rows.indexOf(row) - 1]
    if (!next) return
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "next"
    input.value = next.id
    event.target.appendChild(input)
  }
}
